const initialiseNavSearch = () => {
  const searchToggle = document.getElementById(
    "search-toggle"
  ) as HTMLButtonElement;
  const searchDropdown = document.getElementById(
    "search-dropdown"
  ) as HTMLDivElement;
  const searchInput = searchDropdown.querySelector(
    'input[type="search"]'
  ) as HTMLInputElement;

  searchToggle.addEventListener("click", () => {
    const isExpanding = !searchDropdown.classList.contains("active");
    searchDropdown.classList.toggle("active");
    searchToggle.setAttribute("aria-expanded", isExpanding.toString());

    if (isExpanding) {
      setTimeout(() => {
        searchInput?.focus();
      }, 0);
    }
  });

  document.addEventListener("click", (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    if (!searchToggle.contains(target) && !searchDropdown.contains(target)) {
      searchDropdown.classList.remove("active");
      searchToggle.setAttribute("aria-expanded", "false");
    }
  });
};

export default initialiseNavSearch;
